export default __webpack_public_path__ + "static/media/vijaywadaDeitieTwo.35e44c3f.png";